const questionRegExp = /^[a-z]*q[a-z]?\d+/i
const deepCopy = obj => JSON.parse(JSON.stringify(obj))

const ignoredVariables = ['GROUP', 'PANEL', 'STATUS', 'MSA', 'TAG']

export default aytmLogic => {
  const customVariables = aytmLogic.customVariables || {}

  const refs = Object.keys(aytmLogic.refsList)
  const refsList = deepCopy(aytmLogic.refsList)

  const questions = refs.filter(ref => questionRegExp.test(ref))
  const clusters = ((aytmLogic.assets || [])['hm.cluster'] || []).map(cluster => cluster.title)
  const sections = (aytmLogic.questions || [])
    .filter(q => 'mn' === q.type && q.sections)
    .flatMap(q => q.sections.map(s => s.text))
    .filter((v, i, a) => a.indexOf(v) === i)
  const traits = deepCopy(aytmLogic.traits)
  const variables = refs.filter(
    ref =>
      !questionRegExp.test(ref) &&
      -1 === ignoredVariables.indexOf(ref) &&
      (!Object.hasOwn(customVariables, ref.toLowerCase()) || 'x' !== customVariables[ref.toLowerCase()].type)
  )
  const codebooks = deepCopy(aytmLogic.codeBooks || {})
  const tags = deepCopy(aytmLogic.tags || {})

  return {
    refsList,
    questions,
    clusters,
    sections,
    traits,
    variables,
    codebooks,
    tags
  }
}
